import { useCallback } from 'react';

import { useAnalyticsUtilities } from '@air/analytics';

import META from '~/hooks/events/useTrackIntegrationPluginOpened.meta';

export const useTrackIntegrationPluginOpened = () => {
  const { track } = useAnalyticsUtilities();

  const trackIntegrationPluginOpened = useCallback(() => {
    track(META.name);
  }, [track]);

  return { trackIntegrationPluginOpened };
};
